import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ShoppingCart, ChevronUp, ChevronDown, User, ExternalLink, Download } from 'lucide-react';
import { siteContent } from '../data/siteContent';
import { useTranslation } from '../context/TranslationContext';
import { useCart } from '../context/CartContext';
import LanguageSwitcher from './LanguageSwitcher';
import CurrencySwitcher from './CurrencySwitcher';
import CookieConsent from './CookieConsent';
import { FooterNewsletter } from './FooterNewsletter';

var socialLinks = [
  { name: 'YouTube', url: 'https://www.youtube.com/trumpet95', icon: 'youtube' },
  { name: 'Instagram', url: 'https://www.instagram.com/isa_plays_music', icon: 'instagram' },
  { name: 'Facebook', url: 'https://www.facebook.com/Isaias-Jimenez-644745092582256/', icon: 'facebook' },
  { name: 'X', url: 'https://twitter.com/IsaiasJiMendez', icon: 'x' },
  { name: 'Apple Music', url: 'https://music.apple.com/mx/artist/isaias-jimenez/1250196221', icon: 'apple' },
  { name: 'Spotify', url: 'https://open.spotify.com/artist/1vYTdPu2YzXcixfTeHW6mj', icon: 'spotify' },
];

var innovationsLinks = [
  { name: 'BelloFlex Mutes', path: '/belloflex' },
  { name: 'NoteTurner', path: '/noteturner' },
  { name: 'CapKit', path: '/product/capkit' },
  { name: 'MuteClip', path: '/muteclip' },
  { name: 'Brass Plank', path: '/brass-plank' },
];

var moreLinks = [
  { name: 'Music', path: '/music' },
  { name: 'Gallery', path: '/gallery' },
  { name: 'Lessons', path: '/lessons' },
  { name: 'Contact', path: '/contact' },
  { name: 'Terms', path: '/terms' },
  { name: 'Privacy', path: '/privacy' },
];

function SocialIcon(props) {
  var icon = props.icon;
  var className = props.className || 'w-5 h-5';
  
  if (icon === 'youtube') {
    return (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    );
  }
  if (icon === 'instagram') {
    return (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
      </svg>
    );
  }
  if (icon === 'apple') {
    return (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/>
      </svg>
    );
  }
  if (icon === 'spotify') {
    return (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
      </svg>
    );
  }
  if (icon === 'facebook') {
    return (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    );
  }
  if (icon === 'x') {
    return (
      <svg className={className} fill="currentColor" viewBox="0 0 24 24">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    );
  }
  return null;
}

function Navigation() {
  var { t } = useTranslation();
  var cart = useCart();
  var menuState = useState(false);
  var isOpen = menuState[0];
  var setIsOpen = menuState[1];

  var scrollState = useState(false);
  var scrolled = scrollState[0];
  var setScrolled = scrollState[1];

  var innovationsState = useState(false);
  var innovationsOpen = innovationsState[0];
  var setInnovationsOpen = innovationsState[1];

  var moreState = useState(false);
  var moreOpen = moreState[0];
  var setMoreOpen = moreState[1];

  var location = useLocation();

  useEffect(function() {
    function handleScroll() {
      setScrolled(window.scrollY > 50);
    }
    window.addEventListener('scroll', handleScroll);
    return function() {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(function() {
    setIsOpen(false);
    setInnovationsOpen(false);
    setMoreOpen(false);
  }, [location]);

  function toggleInnovations() {
    setInnovationsOpen(!innovationsOpen);
    setMoreOpen(false);
  }

  function toggleMore() {
    setMoreOpen(!moreOpen);
    setInnovationsOpen(false);
  }

  function getNavClass(path) {
    if (location.pathname === path) {
      return 'px-2.5 xl:px-3 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap text-black bg-[#d4af37]';
    }
    return 'px-2.5 xl:px-3 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap text-neutral-400 hover:text-white hover:bg-white/5';
  }

  var navBgClass = scrolled 
    ? 'fixed w-full z-50 transition-all duration-500 bg-black/80 backdrop-blur-xl border-b border-white/5' 
    : 'fixed w-full z-50 transition-all duration-500 bg-transparent';

  // Shift the nav down by the combined height of any promotional banners
  // (0px each when inactive). Order top→bottom: HolidayBanner then
  // FreeShippingBanner. Each publishes its own CSS var.
  var navStyle = { top: 'calc(var(--holiday-banner-h, 0px) + var(--free-shipping-banner-h, 0px))' };

  var innovationsChevronClass = innovationsOpen ? 'w-4 h-4 transition-transform rotate-180' : 'w-4 h-4 transition-transform';
  var moreChevronClass = moreOpen ? 'w-4 h-4 transition-transform rotate-180' : 'w-4 h-4 transition-transform';

  return (
    <nav data-testid="main-navigation" className={navBgClass} style={navStyle}>
      <div className="max-w-[1700px] mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20 gap-2">
          {/* Mobile hamburger — left side, always visible on phones */}
          <button data-testid="mobile-menu-toggle" onClick={function() { setIsOpen(!isOpen); }} className="lg:hidden p-2 -ml-2 text-white flex-shrink-0" aria-label="Toggle menu">
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>

          <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 flex-shrink-0">
            <img src={siteContent.brand.logo} alt="JiMendez Logo" className="h-10 w-auto object-contain" />
            <span className="hidden md:block text-base text-white" style={{fontFamily: "'Cormorant Garamond', serif", fontWeight: 600}}>JiMendez</span>
          </Link>

          <div className="hidden lg:flex items-center gap-0.5 min-w-0">
            <Link to="/" className={getNavClass('/')}>{t('home')}</Link>
            <Link to="/bio" className={getNavClass('/bio')}>{t('bio')}</Link>
            <Link to="/shop" className={getNavClass('/shop')}>{t('shop')}</Link>
            <Link to="/forscore" className={getNavClass('/forscore')}>ForScore</Link>
            <Link to="/mobilesheets" className={getNavClass('/mobilesheets')}>MobileSheets</Link>
            <Link to="/arrangements" className={getNavClass('/arrangements')}>{t('arrangements') || 'Arrangements'}</Link>
            
            <div className="relative">
              <button onClick={toggleInnovations} className="flex items-center gap-1 px-4 py-2 rounded-full text-sm font-medium text-neutral-400 hover:text-white hover:bg-white/5 transition-all">
                {t('innovations')}
                <ChevronDown className={innovationsChevronClass} />
              </button>
              {innovationsOpen && (
                <div className="absolute top-full left-0 mt-2 w-56 bg-neutral-900 border border-white/10 rounded-xl py-2 shadow-xl">
                  <Link to="/belloflex" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">BelloFlex Mutes</Link>
                  <Link to="/noteturner" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">NoteTurner</Link>
                  <Link to="/product/capkit" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">CapKit</Link>
                  <Link to="/muteclip" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">MuteClip</Link>
                  <Link to="/brass-plank" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">Brass Plank</Link>
                  <Link to="/product/armis-bellguard" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">Armis BellGuard</Link>
                  <Link to="/product/armis-leather-trumpet-sleeve" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">Armis Leather Sleeve</Link>
                </div>
              )}
            </div>

            <Link to="/toneregistry" className={getNavClass('/toneregistry')}>ToneRegistry</Link>

            <div className="relative">
              <button onClick={toggleMore} className="flex items-center gap-1 px-4 py-2 rounded-full text-sm font-medium text-neutral-400 hover:text-white hover:bg-white/5 transition-all">
                {t('more')}
                <ChevronDown className={moreChevronClass} />
              </button>
              {moreOpen && (
                <div className="absolute top-full left-0 mt-2 w-48 bg-neutral-900 border border-white/10 rounded-xl py-2 shadow-xl">
                  <Link to="/music" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">Music</Link>
                  <Link to="/gallery" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">Gallery</Link>
                  <Link to="/lessons" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">Lessons</Link>
                  <Link to="/faq" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">FAQ</Link>
                  <Link to="/distributors" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">Distributors</Link>
                  <Link to="/contact" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">Contact</Link>
                  <Link to="/terms" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">Terms</Link>
                  <Link to="/privacy" className="block px-4 py-2 text-sm text-neutral-400 hover:text-white hover:bg-white/5">Privacy</Link>
                </div>
              )}
            </div>
          </div>

          <div className="flex items-center gap-2 flex-shrink-0">
            <LanguageSwitcher />
            <CurrencySwitcher />
            <Link
              to="/my-downloads"
              data-testid="nav-my-downloads"
              className="hidden lg:inline-flex items-center gap-2 px-3 py-2 rounded-full border border-[#d4af37]/60 text-[#d4af37] text-sm font-semibold hover:bg-[#d4af37] hover:text-black transition-colors whitespace-nowrap"
            >
              <Download className="w-4 h-4" />
              <span className="hidden xl:inline">My Downloads</span>
              <span className="xl:hidden">Downloads</span>
            </Link>
            <a href="https://www.toneregistry.com/account/my-account" target="_blank" rel="noopener noreferrer" data-testid="nav-account-button" className="hidden sm:inline-flex p-2 text-white/70 hover:text-[#d4af37] hover:bg-white/10 rounded-lg transition-all" aria-label="My Account">
              <User className="w-5 h-5" />
            </a>
            <button onClick={function() { cart.setIsOpen(true); }} data-testid="nav-cart-button" className="p-2.5 text-black bg-[#d4af37] hover:bg-[#e6c14b] rounded-full transition-all relative flex-shrink-0 shadow-lg shadow-[#d4af37]/20" aria-label="Cart">
              <ShoppingCart className="w-5 h-5" strokeWidth={2.4} />
              {cart.totalItems > 0 && <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-black text-[#d4af37] text-xs font-bold flex items-center justify-center border border-[#d4af37]">{cart.totalItems}</span>}
            </button>
          </div>
        </div>
      </div>

      {isOpen && (
        <div className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/5 max-h-[80vh] overflow-y-auto">
          <div className="px-6 py-6 space-y-1">
            <button
              onClick={function() { setIsOpen(false); cart.setIsOpen(true); }}
              data-testid="mobile-menu-cart"
              className="w-full flex items-center justify-between px-4 py-3 rounded-xl text-base font-semibold text-black bg-[#d4af37] hover:bg-white mb-3"
            >
              <span className="flex items-center gap-2"><ShoppingCart className="w-5 h-5" /> {t('cart') || 'Cart'}</span>
              {cart.totalItems > 0 ? <span className="px-2 py-0.5 rounded-full bg-black text-[#d4af37] text-xs font-bold">{cart.totalItems}</span> : null}
            </button>
            <Link
              to="/my-downloads"
              data-testid="mobile-menu-my-downloads"
              className="w-full flex items-center gap-2 px-4 py-3 rounded-xl text-base font-semibold text-[#d4af37] border border-[#d4af37]/60 hover:bg-[#d4af37] hover:text-black transition-colors mb-3"
            >
              <Download className="w-5 h-5" />
              My Downloads
            </Link>
            <Link to="/" className="block px-4 py-3 rounded-xl text-base font-medium text-white">{t('home')}</Link>
            <Link to="/bio" className="block px-4 py-3 rounded-xl text-base font-medium text-white">{t('bio')}</Link>
            <Link to="/shop" className="block px-4 py-3 rounded-xl text-base font-medium text-white">{t('shop')}</Link>
            <Link to="/forscore" className="block px-4 py-3 rounded-xl text-base font-medium text-white">ForScore</Link>
            <Link to="/mobilesheets" className="block px-4 py-3 rounded-xl text-base font-medium text-white">MobileSheets</Link>
            <Link to="/arrangements" className="block px-4 py-3 rounded-xl text-base font-medium text-white">{t('arrangements') || 'Arrangements'}</Link>
            <p className="px-4 pt-4 pb-2 text-xs uppercase tracking-widest text-[#d4af37] font-semibold">{t('innovations').replace(/^\+/, '')}</p>
            <Link to="/belloflex" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">BelloFlex Mutes</Link>
            <Link to="/noteturner" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">NoteTurner</Link>
            <Link to="/product/capkit" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">CapKit</Link>
            <Link to="/muteclip" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">MuteClip</Link>
            <Link to="/brass-plank" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">Brass Plank</Link>
            <Link to="/product/armis-bellguard" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">Armis BellGuard</Link>
            <Link to="/product/armis-leather-trumpet-sleeve" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">Armis Leather Sleeve</Link>
            <Link to="/toneregistry" className="block px-4 py-3 rounded-xl text-base font-medium text-white">ToneRegistry</Link>
            <p className="px-4 pt-4 pb-2 text-xs uppercase tracking-widest text-[#d4af37] font-semibold">{t('more').replace(/^\+/, '')}</p>
            <Link to="/music" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">{t('music') || 'Music'}</Link>
            <Link to="/gallery" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">{t('gallery') || 'Gallery'}</Link>
            <Link to="/lessons" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">{t('lessons') || 'Lessons'}</Link>
            <Link to="/faq" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">FAQ</Link>
            <Link to="/distributors" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">{t('distributors') || 'Distributors'}</Link>
            <Link to="/contact" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">{t('contact')}</Link>
            <Link to="/terms" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">{t('footerTerms') || 'Terms'}</Link>
            <Link to="/privacy" className="block px-4 py-3 rounded-xl text-base font-medium text-neutral-400">{t('footerPrivacy') || 'Privacy'}</Link>
            
            <div className="pt-4 border-t border-white/10 mt-4">
              <a href="https://www.toneregistry.com/account/my-account" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-4 py-3 rounded-xl text-base font-medium text-[#d4af37]">
                <User className="w-5 h-5" />
                {t('myAccount')}
                <ExternalLink className="w-4 h-4 ml-auto" />
              </a>
            </div>

            <div className="flex items-center justify-center gap-4 pt-4">
              {socialLinks.map(function(social) {
                return (
                  <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="p-2 text-neutral-400 hover:text-[#d4af37] transition-colors" aria-label={social.name}>
                    <SocialIcon icon={social.icon} className="w-5 h-5" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}

function Footer() {
  var { t } = useTranslation();
  return (
    <footer data-testid="main-footer" className="bg-black border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <Link to="/" className="inline-flex items-center gap-3 mb-4">
              <img src={siteContent.brand.logo} alt="JiMendez" className="h-16 w-auto object-contain" />
              <div>
                <p className="text-white text-lg" style={{fontFamily: "'Cormorant Garamond', serif", fontWeight: 600}}>JiMendez</p>
                <p className="text-[#d4af37] text-xs tracking-wide">MUSICIAN | ARRANGER | DESIGNER | DEVELOPER | INVENTOR</p>
              </div>
            </Link>
            <p className="text-neutral-500 max-w-md text-sm leading-relaxed mb-6">
              {t('footerTagline')}
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map(function(social) {
                return (
                  <a key={social.name} href={social.url} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-neutral-400 hover:text-[#d4af37] hover:border-[#d4af37] transition-all" aria-label={social.name}>
                    <SocialIcon icon={social.icon} className="w-4 h-4" />
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-neutral-600 mb-4 font-semibold">{t('footerInnovations')}</h4>
            <ul className="space-y-2">
              <li><Link to="/belloflex" className="text-neutral-400 hover:text-[#d4af37] transition-colors text-sm">BelloFlex Mutes</Link></li>
              <li><Link to="/noteturner" className="text-neutral-400 hover:text-[#d4af37] transition-colors text-sm">NoteTurner</Link></li>
              <li><Link to="/muteclip" className="text-neutral-400 hover:text-[#d4af37] transition-colors text-sm">MuteClip</Link></li>
              <li><Link to="/brass-plank" className="text-neutral-400 hover:text-[#d4af37] transition-colors text-sm">Brass Plank</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-neutral-600 mb-4 font-semibold">{t('footerMore')}</h4>
            <ul className="space-y-2">
              <li><Link to="/music" className="text-neutral-400 hover:text-[#d4af37] transition-colors text-sm">{t('footerMusic')}</Link></li>
              <li><Link to="/gallery" className="text-neutral-400 hover:text-[#d4af37] transition-colors text-sm">{t('footerGallery')}</Link></li>
              <li><Link to="/lessons" className="text-neutral-400 hover:text-[#d4af37] transition-colors text-sm">{t('footerLessons')}</Link></li>
              <li><Link to="/contact" className="text-neutral-400 hover:text-[#d4af37] transition-colors text-sm">{t('footerContact')}</Link></li>
              <li><a href="mailto:trumpet95@gmail.com" className="text-neutral-400 hover:text-[#d4af37] transition-colors text-sm">trumpet95@gmail.com</a></li>
              <li><a href="https://www.toneregistry.com/account/my-account" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-[#d4af37] transition-colors text-sm inline-flex items-center gap-1">{t('footerMyAccount')} <ExternalLink className="w-3 h-3" /></a></li>
            </ul>
          </div>
        </div>

        <FooterNewsletter />

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-neutral-600 text-sm">&copy; {new Date().getFullYear()} JiMendez. {t('footerRights')}</p>
          <div className="flex items-center gap-6">
            <Link to="/my-downloads" data-testid="footer-my-downloads" className="text-[#d4af37]/80 hover:text-[#d4af37] text-sm font-medium">My downloads</Link>
            <Link to="/contact" className="text-neutral-600 hover:text-[#d4af37] text-sm">{t('footerContact')}</Link>
            <Link to="/privacy" className="text-neutral-600 hover:text-[#d4af37] text-sm">{t('footerPrivacy')}</Link>
            <Link to="/terms" className="text-neutral-600 hover:text-[#d4af37] text-sm">{t('footerTerms')}</Link>
            <Link to="/refund" className="text-neutral-600 hover:text-[#d4af37] text-sm">{t('footerRefund')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function Layout(props) {
  var children = props.children;
  var scrollState = useState(false);
  var showScrollTop = scrollState[0];
  var setShowScrollTop = scrollState[1];

  useEffect(function() {
    function handleScroll() {
      setShowScrollTop(window.scrollY > 500);
    }
    window.addEventListener('scroll', handleScroll);
    return function() {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  var scrollButtonClass = showScrollTop 
    ? 'fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-[#d4af37] text-black flex items-center justify-center shadow-lg hover:scale-110 transition-transform' 
    : 'hidden';

  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />
      <main>{children}</main>
      <Footer />
      <CookieConsent />
      <button onClick={scrollToTop} data-testid="scroll-to-top" className={scrollButtonClass} aria-label="Scroll to top">
        <ChevronUp className="w-6 h-6" />
      </button>
    </div>
  );
}

export default Layout;
